/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';

import { Icon } from '../../../ui/Icon';

import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.style';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { modalIds, ModalsConsumer } from '../../../../contexts/ModalsContext';
import { compose } from 'lodash/fp';
import { withConsumer } from '../../../../contexts';
import { Picture } from '../../../ui/Picture';
import { Breakpoints } from '../../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../../utils/constants';
import Getanchor from './getAnchor';
const mainImageSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    gravity: 'auto:subject',
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    gravity: 'auto:subject',
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    gravity: 'auto:subject',
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    gravity: 'auto:subject',
  },
};
export class ContentBlock extends SafePureComponent {
  renderCTA = (CTA, checkModalFlag) => {
    // if (CTA.link === modalIds.shopDecisionPoint ) {
    if (this.props.showModal && checkModalFlag) {
      return (
        <button
          onClick={() => {
            this.props.modalsContext.openModal(modalIds.shopDecisionPoint, {});
          }}
        >
          <span>{CTA.text}</span>
          <span>
            <Icon name="chevron-right" />
          </span>
        </button>
      );
    }
    console.log('<<', this.props);
    return (
      <Getanchor
        text={CTA.text}
        link={CTA.link}
        LocationInformation={this.props.LocationInformation}
      />
    );
  };

  safeRender() {
    const { icon, title, desc, CTA1, CTA2, textColor } = this.props;

    const imageSrc = {
      value: { src: icon, alt: 'Shop icon' },
    };

    return (
      <React.Fragment>
        <div
          css={[styles.itemsBoxCss, styles.getHighlightTxt(textColor)]}
          className="leftseccontent"
        >
          {/* {icon && <img src={icon} alt="banner img" />} */}
          {icon && (
            <Picture
              image={imageSrc}
              imageSizes={mainImageSizes}
              // pictureCss={previewImageStyleImage}
              editable={false}
            />
          )}
          <RichText field={{ value: title, editable: false }} tag="h2" />
          {desc && <p>{desc}</p>}
          <div className="findoutlink">
            {CTA1.link && this.renderCTA(CTA1, true)}
            {CTA2.link && this.renderCTA(CTA2, false)}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ContentBlock.displayName = 'Shop/ContentBlock';

// export default withNamespaces()(ContentBlock);

export default compose(
  withNamespaces(),
  withConsumer(ModalsConsumer, 'modalsContext'),
)(ContentBlock);
